import React from "react";
import { Helmet } from "react-helmet";
import "../Privacypolicy/Privacypolicy.css";

const Privacypolicy = () => {
  return (
    <>
    

<Helmet>
  {/* ----------------------------------------------------
     BASIC SEO TAGS
  ---------------------------------------------------- */}
  <title>Irish Platinum – Disclaimer & Privacy Policy | Privacy Page</title>
  <meta
    name="description"
    content="Read the Disclaimer & Privacy Policy for Irish Platinum, operated by authorized channel partner Shishir. Understand our website usage, personal data protection, and RERA compliance details."
  />
  <meta
    name="keywords"
    content="Irish Platinum, Disclaimer, Privacy Policy, Irish Platinum Privacy Page, Irish Platinum Noida Extension, Authorized Channel Partner, RERA Compliance, Data Protection, Website Disclaimer"
  />
  <link rel="canonical" href="https://irishplatinum.org/privacy" />
  <meta name="robots" content="index, follow" />
  <meta name="theme-color" content="#ffffff" />

  {/* ----------------------------------------------------
     OPEN GRAPH TAGS
  ---------------------------------------------------- */}
  <meta property="og:title" content="Irish Platinum – Disclaimer & Privacy Policy" />
  <meta
    property="og:description"
    content="Read the Disclaimer & Privacy Policy for Irish Platinum, including information about website use, RERA compliance, and personal data protection."
  />
  <meta property="og:image" content="https://irishplatinum.org/i1.webp" />
  <meta property="og:url" content="https://irishplatinum.org/privacy" />
  <meta property="og:type" content="website" />

  {/* ----------------------------------------------------
     TWITTER META TAGS
  ---------------------------------------------------- */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Irish Platinum – Disclaimer & Privacy Policy" />
  <meta
    name="twitter:description"
    content="Read the Disclaimer & Privacy Policy for Irish Platinum, operated by authorized channel partner Shishir, including website usage, data protection, and RERA compliance."
  />
  <meta name="twitter:image" content="https://irishplatinum.org/i1.webp" />

  {/* ----------------------------------------------------
     JSON-LD SCHEMA
  ---------------------------------------------------- */}
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "name": "Irish Platinum",
            "url": "https://irishplatinum.org/",
            "logo": "https://irishplatinum.org/ico.png",
            "sameAs": ["https://irishplatinum.org/"],
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+919654945825",
                "contactType": "Sales",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi"]
              }
            ],
            "founder": "Irish Group",
            "description": "Irish Platinum is a premium residential project offering luxury 3 & 4 BHK apartments in Sector 10 Greater Noida West with world-class amenities and excellent connectivity."
          },
          {
            "@type": "WebPage",
            "name": "Privacy Policy & Disclaimer",
            "url": "https://irishplatinum.org/privacy",
            "description": "This page contains the Disclaimer & Privacy Policy for Irish Platinum, operated by authorized channel partner Shishir, covering website usage, data protection, and RERA compliance.",
            "publisher": {
              "@type": "Organization",
              "name": "Irish Platinum",
              "logo": {
                "@type": "ImageObject",
                "url": "https://irishplatinum.org/ico.png"
              }
            }
          },
          {
            "@type": "ContactPage",
            "url": "https://irishplatinum.org/privacy",
            "name": "Irish Platinum Privacy Inquiry",
            "contactType": "Privacy & Disclaimer",
            "description": "Users can contact Irish Platinum regarding privacy concerns or for any queries about website usage and disclaimer policies.",
            "provider": {
              "@type": "RealEstateAgent",
              "name": "Authorized Channel Partner - Shishir",
              "identifier": "UP RERA Registration No. UPRERAAGT24002"
            }
          }
        ]
      })
    }}
  />
</Helmet>

 
    <section className="privacy-policy">
      <h4 className="hh">Disclaimer & Privacy Policy</h4>
      <div className="container">
        {/* Disclaimer Section */}
        <h2>Disclaimer</h2>
        <p>
          This website is operated by an authorized channel partner of Irish Groups , UP RERA Registration No. UPRERAPRJ503189/03/2024. The content
          provided on this website is strictly for informational purposes. All
          images are for representational use only. Prices are subject to change
          without notice, and the availability of properties is not guaranteed.
          By accessing this website, users confirm that the information,
          including brochures and marketing materials, is solely for reference
          purposes, and no reliance should be placed on this information for
          making any booking or purchase of property in any project of the
          company. This website does not constitute advertising, marketing,
          booking, selling, or an offer to sell, nor does it represent an
          invitation to purchase any unit in any project of the company. The
          company assumes no liability for any actions taken by the user based
          on material or information from this website. The company has taken
          steps to verify the information and project compliances, including
          ensuring that the projects listed comply with the Real Estate
          Regulation Act (RERA) 2016. However, users should independently verify
          the RERA registration status of real estate projects before making any
          purchase decisions.
        </p>

        {/* Privacy Policy Section */}
        <h2>Privacy Policy</h2>
        <p>
          We are committed to protecting your personal information and have
          designed this privacy policy to safeguard your interests while using
          our website.
        </p>

        <h3>Updating Our Privacy Policy</h3>
        <p>
          This privacy policy is subject to periodic review and updates without
          prior notice. To stay informed of any changes, we encourage you to
          regularly review this policy.
        </p>

        <h3>User Information</h3>
        <p>
          By using our website, you agree to abide by our terms and consent to
          the collection and use of any personal information you provide. While
          some sections of our website do not require personal information,
          certain features may require you to provide details such as your name,
          email address, or phone number. This information is used to deliver
          relevant services and to respond to communications or provide updates.
          You may opt out of our mailing list at any time. Rest assured, we do
          not share your personal information with any third party without your
          consent.
        </p>

        <h3>Security</h3>
        <p>
          To ensure the security of your sensitive information during
          transmission, we utilize advanced encryption protocols for all
          exchanges between your device and our servers. We also enforce
          restricted access and maintain high levels of confidentiality within
          our organization.
        </p>
      </div>
    </section>
       </>
  );
};

export default Privacypolicy;
